import { Sites } from '@ps/platform-message-framework/common/Sites';
import { RawInput, Translation } from '@ps/web-shared-components';
import { required } from '@ps/web-shared-validators';
import classNames from 'clsx';
import React from 'react';
import { useForm } from 'react-final-form';
import { useSelector } from 'react-redux';

import { Country } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { FieldNameProp } from '@swf/core/types/Props';

import { getCountryStates } from '../../../../../../../utils/country-states/country-states';
import InfoPrompt from '../../../../../../InfoPrompt/InfoPrompt';
import State, { findState } from '../../../../../../State/State';
// TODO refactor to use composition or shared.scss
import { label, root } from '../../../../../../TextInput/TextInput.scss';
import RMFDropDown from '../../../../RMFDropDown/RMFDropDown';
// TODO refactor to use composition or shared.scss
import { info, infoText, inputText } from '../Fields.scss';

import {
  TXTCLI_Please_select_State___Province_ELL,
  TXTCLI_Province,
  TXTWCL_Province_cannot_be_changed,
  TXTWCL_Select_province,
  TXTWCL_You_must_be_a_resident_of_Onta_ELL
} from './StateField.messages.json';

interface Props extends FieldNameProp {
  country: string;
}

const StateField: React.FC<Props> = ({ fieldName, country }) => {
  const form = useForm();
  const siteId = useSelector(select.cms.getSiteId);
  const countryStates = getCountryStates(country);

  const resetCityState = () => {
    form.change('city');
    form.resetFieldState('city');
  };

  switch (true) {
    case siteId === Sites.CA_ON:
      return (
        <RawInput
          id={fieldName}
          label={TXTCLI_Province}
          labelClassName={classNames(label, info)}
          labelContent={
            <InfoPrompt title={{ translation: TXTWCL_Province_cannot_be_changed }}>
              <p className={infoText}>
                <Translation {...TXTWCL_You_must_be_a_resident_of_Onta_ELL} />
              </p>
            </InfoPrompt>
          }
          rawValue={findState('ON', countryStates)?.text}
          className={classNames(root, inputText)}
          disabled
        />
      );
    case siteId === Sites.FRA && country === Country.France:
      return (
        <RMFDropDown
          id={fieldName}
          label={TXTCLI_Province}
          options={countryStates}
          onSelect={resetCityState}
          validators={[required(TXTCLI_Please_select_State___Province_ELL)]}
          placeholder={<Translation {...TXTWCL_Select_province} />}
        />
      );
    default:
      return <State country={country} fieldName={fieldName} />;
  }
};

export default StateField;
